import React from 'react';
import { isNil } from 'lodash';
import cx from 'classnames';
import styles from './Overview.module.scss';
import DataMapSamplesContainer from 'js/components/data_maps/DataMapSamplesContainer';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_DATA_MAP_DOC_REQUEST } from 'js/constants/actionTypes';
import DocEditor from 'js/components/elements/editors/DocEditor';
import { useResourceDoc } from 'new/hooks/adapters/useResourceDoc';
import { RESOURCE_TYPE_DATA_MAP } from 'js/constants/resourceTypes';

interface LookupProps {
  resource: any;
}

export const LookupOverview = (props: LookupProps) => {
  const { resource } = props;
  const doc = useResourceDoc(RESOURCE_TYPE_DATA_MAP, resource?.id);
  const isLoadingDoc = useIsLoading(GET_DATA_MAP_DOC_REQUEST);

  return (
    <div className={cx(styles.overviewContainer, styles.lookupOverviewContainer, 'detail-view')}>
      <div className="tab-content">
        {!isNil(doc) && !isLoadingDoc ? (
          <DocEditor data={resource} doc={doc} readOnly isLoading={isLoadingDoc} />
        ) : null}
        <h2 className={styles.lookupHeader}>Lookup Preview</h2>
        <div className={styles.dataMapSamplesContainer}>
          <DataMapSamplesContainer preventInitialFetch data={resource} />
        </div>
      </div>
    </div>
  );
};
